import React from 'react';

import { ManageContractsApp } from '../contractManagementContext';
import OldContract from '../sections/OldContract';
import ChangeType from './ChangeType';
import ChangeServices from './ChangeServices';
import ChangePayment from './ChangePayment';

export const ChangeBase: React.FunctionComponent = () => {
  const { selectedForm4, oldContract } = ManageContractsApp.useState();

  return (
    <>
      <OldContract />
      {oldContract && (
        <>
          {selectedForm4 === 1 && <ChangeType />}
          {selectedForm4 === 2 && <ChangePayment />}
          {selectedForm4 === 3 && <ChangeServices />}
        </>
      )}
    </>
  );
};

export default ChangeBase;
